function initMap()
{
	var latlng = {
		lat: 34.365111,
		lng:  132.478154
	};

	var map = new google.maps.Map(document.getElementById('gmap'), {
		center: latlng,
		zoom: 16,
		scrollwheel: false,
	});

	var marker = new google.maps.Marker({
		position: latlng,
		map: map,
		title: 'FLAG SYSTEM'
	});

	var contentString = '<div id="content">\
	<div id="siteNotice">\
		<h1 id="firstHeading" class="firstHeading">FLAG SYSTEM</h1>\
		<div id="bodyContent">\
			<p>広島市南区丹那町20-25</p>\
		</div>\
	</div>\
	</div>';

	var infowindow = new google.maps.InfoWindow({
		content: contentString,
		maxWidth: 300
	});

	google.maps.event.addListener(marker, 'click', function() {
		infowindow.open(map, marker);
	});

	google.maps.event.addDomListener(window, 'resize', function() {
		google.maps.event.trigger(map, 'resize');
		map.panTo(marker.getPosition());
	});

	map.addListener('zoom_changed', function() {
		map.panTo(marker.getPosition());
	});
}

window.initMap = initMap;
